<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center gap-3 mb-2">
      <button (click)="goBack()" class="p-2 hover:bg-gray-200 rounded-lg transition-colors">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div class="p-2 bg-blue-500 rounded-lg">
        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Conciliación #{{ logId }}</h1>
        <p class="text-gray-500 text-sm">Detalle de la ejecución de conciliación automática</p>
      </div>
    </div>
  </div>

  <div *ngIf="log">
    <!-- Summary Cards -->
    <div class="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      <div class="bg-white rounded-lg border border-gray-200 p-4">
        <div class="flex items-center gap-3">
          <div class="p-2 bg-gray-100 rounded-lg">
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <div>
            <p class="text-xs text-gray-500">Procesados</p>
            <p class="text-xl font-bold text-gray-800">{{ log.totalProcessed }}</p>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg border border-green-200 p-4">
        <div class="flex items-center gap-3">
          <div class="p-2 bg-green-100 rounded-lg">
            <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <p class="text-xs text-green-600">Conciliados</p>
            <p class="text-xl font-bold text-green-700">{{ log.totalConciliated }}</p>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg border border-red-200 p-4">
        <div class="flex items-center gap-3">
          <div class="p-2 bg-red-100 rounded-lg">
            <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <div>
            <p class="text-xs text-red-600">Fallidos</p>
            <p class="text-xl font-bold text-red-700">{{ log.totalFailed }}</p>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg border border-amber-200 p-4">
        <div class="flex items-center gap-3">
          <div class="p-2 bg-amber-100 rounded-lg">
            <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p class="text-xs text-amber-600">Pendientes</p>
            <p class="text-xl font-bold text-amber-700">{{ log.totalPending }}</p>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg border border-gray-200 p-4">
        <div class="flex items-center gap-3">
          <div class="p-2 bg-blue-100 rounded-lg">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p class="text-xs text-gray-500">Duración</p>
            <p class="text-xl font-bold text-gray-800">{{ formatDuration(log.executionTimeMs) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div class="bg-white rounded-lg border border-gray-200 p-4">
        <p class="text-sm text-gray-500 mb-1">Fecha de Ejecución</p>
        <p class="font-medium text-gray-800">{{ formatDate(log.executionDate) }}</p>
      </div>
      <div class="bg-white rounded-lg border border-gray-200 p-4">
        <p class="text-sm text-gray-500 mb-1">Estado</p>
        <span class="px-3 py-1 text-sm font-medium rounded-full" [ngClass]="getStatusBadgeClasses(log.status)">
          {{ log.statusName }}
        </span>
      </div>
      <div class="bg-white rounded-lg border border-gray-200 p-4">
        <p class="text-sm text-gray-500 mb-1">Notificación Email</p>
        <p class="font-medium" [class.text-green-600]="log.emailNotificationSent" [class.text-gray-500]="!log.emailNotificationSent">
          {{ log.emailNotificationSent ? 'Enviado el ' + formatDate(log.emailSentAt) : 'No enviado' }}
        </p>
      </div>
    </div>

    <!-- Error Details -->
    <div *ngIf="log.errorDetails" class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <h3 class="text-sm font-medium text-red-800 mb-2 flex items-center gap-2">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.232 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        Errores durante la ejecución
      </h3>
      <pre class="text-xs text-red-700 whitespace-pre-wrap bg-red-100 rounded p-3 overflow-x-auto">{{ log.errorDetails }}</pre>
    </div>

    <!-- Conciliated Payments Table -->
    <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div class="px-4 py-3 border-b border-gray-200 bg-gray-50">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Pagos Conciliados
          </h3>
          <span class="text-sm text-gray-500">{{ payments.length }} registros</span>
        </div>
      </div>

      <div *ngIf="payments.length > 0" class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID Recibo</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID Conciliación</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Monto Bruto</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Comisión</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">ReteFuente</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">ReteIVA</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">ReteICA</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Total Desctos</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Monto Neto</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let payment of paginatedPayments" class="hover:bg-gray-50">
              <td class="px-4 py-3 whitespace-nowrap">
                <span class="text-sm font-medium text-blue-600">#{{ getIncomeReceiptId(payment) }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-600 font-mono">{{ getReconciliationId(payment) }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm font-medium text-gray-900">{{ getGrossAmount(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm text-red-600">{{ getCommissionValue(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm text-red-600">{{ getReteFuenteValue(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm text-red-600">{{ getReteIVAValue(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm text-red-600">{{ getReteICAValue(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm font-medium text-red-700">{{ getTotalFees(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-right">
                <span class="text-sm font-bold text-green-600">{{ getNetAmount(payment) | currency:'COP':'symbol':'1.0-0' }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-500">{{ formatDate(getConciliatedAt(payment)) }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-center">
                <button (click)="viewIncomeReceipt(payment)" 
                        class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  Ver Comprobante
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty State -->
      <div *ngIf="payments.length === 0" class="px-4 py-12 text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <p class="mt-2 text-gray-500">No hay pagos conciliados en esta ejecución</p>
      </div>

      <!-- Pagination -->
      <div *ngIf="payments.length > pageSize" class="bg-gray-50 px-4 py-3 flex items-center justify-between border-t border-gray-200">
        <div class="text-sm text-gray-700">
          Mostrando {{ ((currentPage - 1) * pageSize) + 1 }} - {{ Math.min(currentPage * pageSize, payments.length) }} de {{ payments.length }}
        </div>
        <div class="flex gap-2">
          <button (click)="prevPage()" 
                  [disabled]="currentPage === 1"
                  class="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            Anterior
          </button>
          <span class="px-3 py-1 text-sm text-gray-600">
            Página {{ currentPage }} de {{ totalPages }}
          </span>
          <button (click)="nextPage()" 
                  [disabled]="currentPage >= totalPages"
                  class="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
            Siguiente
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="flex items-center justify-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
</div>

